import "../css/header.scss";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);

  const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header" role="banner">
      <div className="header-container">
        <Link to="/" className="logo-link" onClick={toTop}>
          <img className="brand-logo" src="/head/slayfulpawsco-logo.svg" alt="slayfulpawsco" />
        </Link>

        <nav className="main-nav" role="navigation">
          <Link to="/shop" onClick={toTop} className="nav-link">
            Shop All
          </Link>

          <Link to="/about" onClick={toTop} className="nav-link">
            Discover
          </Link>
          <Link to="/contact" onClick={toTop} className="nav-link">
            Contact Us
          </Link>
          <div className={`nav-dropdown ${moreOpen ? "open" : ""}`}>
            <button
              type="button"
              className="nav-link dropdown-toggle"
              aria-expanded={moreOpen}
              aria-controls="policy-menu"
              onClick={() => setMoreOpen((open) => !open)}
            >
              More <span aria-hidden="true">⌄</span>
            </button>
            <div id="policy-menu" className="dropdown-menu">
              <Link to="/privacy" onClick={() => { toTop(); setMoreOpen(false); }}>Privacy Policy</Link>
              <Link to="/cookies" onClick={() => { toTop(); setMoreOpen(false); }}>Cookie Policy</Link>
              <Link to="/faqs" onClick={() => { toTop(); setMoreOpen(false); }}>FAQs</Link>
              <Link to="/terms" onClick={() => { toTop(); setMoreOpen(false); }}>Terms</Link>
              <Link to="/shipping" onClick={() => { toTop(); setMoreOpen(false); }}>Shipping Policy</Link>
              <Link to="/returns" onClick={() => { toTop(); setMoreOpen(false); }}>Return Policy</Link>
            </div>
          </div>
        </nav>

        <div className="header-actions">
          <Link
            to="/cartpage"
            className="cart-link"
            aria-label={`Cart with ${cartCount} items`}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              width={26}
              height={26}
            >
              <path
                d="M19.431 22.368H4.578L2.235 8.995H8.06a50.91 50.91 0 0 0-.434 2.83.566.566 0 0 0 .56.644.562.562 0 0 0 .553-.494c.126-.996.291-1.997.47-2.975h5.665c.165 1.023.295 2.038.38 2.953a.562.562 0 0 0 .608.516.568.568 0 0 0 .51-.62 49.843 49.843 0 0 0-.353-2.85h5.74l-2.329 13.369zM11.978 1.637c1.117 0 2.088 2.997 2.705 6.217H9.438c.72-3.428 1.708-6.217 2.54-6.217zm10.891 6.421a.57.57 0 0 0-.433-.2h-6.604C15.232 4.53 14.07.5 11.978.5c-1.825 0-3.014 3.967-3.703 7.354h-6.71a.594.594 0 0 0-.434.2.563.563 0 0 0-.121.466l2.548 14.509a.56.56 0 0 0 .55.471h15.793a.555.555 0 0 0 .55-.471l2.54-14.51a.561.561 0 0 0-.122-.461z"
                fill="currentColor"
              />
            </svg>

            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </Link>

          <button
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              {mobileMenuOpen ? (
                <>
                  <path d="M18 6L6 18" />
                  <path d="M6 6l12 12" />
                </>
              ) : (
                <>
                  <path d="M3 12h18" />
                  <path d="M3 6h18" />
                  <path d="M3 18h18" />
                </>
              )}
            </svg>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="mobile-menu">
          <nav className="mobile-nav">
            <Link
              to="/shop"
              onClick={() => {
                toTop();
                setMobileMenuOpen(false);
              }}
            >
              New Arrivals
            </Link>
            <Link
              to="/shop?category=premium"
              onClick={() => {
                toTop();
                setMobileMenuOpen(false);
              }}
            >
              Premium Stationery
            </Link>
            <Link
              to="/shop?category=bundles"
              onClick={() => {
                toTop();
                setMobileMenuOpen(false);
              }}
            >
              Original Bundles
            </Link>
            <Link
              to="/shop"
              onClick={() => {
                toTop();
                setMobileMenuOpen(false);
              }}
            >
              Shop All
            </Link>
            <Link
              to="/about"
              onClick={() => {
                toTop();
                setMobileMenuOpen(false);
              }}
            >
              Discover
            </Link>
            <Link to="/faqs" onClick={() => { toTop(); setMobileMenuOpen(false); }}>FAQs</Link>
            <Link to="/privacy" onClick={() => { toTop(); setMobileMenuOpen(false); }}>Privacy Policy</Link>
            <Link to="/cookies" onClick={() => { toTop(); setMobileMenuOpen(false); }}>Cookie Policy</Link>
            <Link to="/terms" onClick={() => { toTop(); setMobileMenuOpen(false); }}>Terms</Link>
          </nav>
        </div>
      )}
    </header>
  );
}

export default Header;
